import { render, staticRenderFns } from "./OperationalPerformanceLeader.vue?vue&type=template&id=48b842c7&scoped=true"
import script from "./OperationalPerformanceLeader.vue?vue&type=script&lang=ts"
export * from "./OperationalPerformanceLeader.vue?vue&type=script&lang=ts"
import style0 from "./OperationalPerformanceLeader.vue?vue&type=style&index=0&id=48b842c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b842c7",
  null
  
)

export default component.exports